import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { JobCategory_Entity } from "../../entities/jobCategory";
import { filmsApi } from "../api/filmsApi";

const jobCategoriesAdapter = createEntityAdapter<JobCategory_Entity>();
const initialState = jobCategoriesAdapter.getInitialState();

export const jobCategoryEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getJobCategories: build.query<EntityState<JobCategory_Entity>, void>({
      query: () => `jobCategories`,
      transformResponse: (responseData: JobCategory_Entity[]) => {
        return jobCategoriesAdapter.setAll(initialState, responseData);
      },
      providesTags: ["jobCategories"],
    }),
    getJobCategory: build.query<JobCategory_Entity, number>({
      query: (id) => `jobCategories/${id}`,
      providesTags: (result, error, id) => [{ type: "jobCategories", id }],
    }),
    createJobCategory: build.mutation<
      JobCategory_Entity,
      Partial<JobCategory_Entity>
    >({
      query: (body) => ({
        method: "POST",
        body,
        url: `jobCategories`,
      }),
      invalidatesTags: ["jobCategories"],
    }),
    updateJobCategory: build.mutation<
      void,
      { id: number; body: Partial<JobCategory_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `jobCategories/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "jobCategories", id },
        "jobCategories",
      ],
    }),
    deleteJobCategory: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `jobCategories/${id}`,
      }),
      invalidatesTags: ["jobCategories"],
    }),
  }),
});

export const {
  useGetJobCategoryQuery,
  useGetJobCategoriesQuery,
  useCreateJobCategoryMutation,
  useDeleteJobCategoryMutation,
  useUpdateJobCategoryMutation,
} = jobCategoryEndpoints;

export default jobCategoryEndpoints;
